import Zptable from './src/page-content.vue'
export default Zptable
